<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-produto-lote') {
            next({ name: 'ven-produto-lote-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-produto-lote') {
            this.$router.push({ name: 'ven-produto-lote-list' });
        }
    },
};
</script>
